export enum COUNTRIES_ID {
  CN = 'CN',
  FR = 'FR',
  JP = 'JP',
  US = 'US',
  VN = 'VN',
}

export enum AreaCodeEnum {
  CN = '+86',
  FR = '+33',
  JP = '+81',
  US = '+1',
  VN = '+84',
}
